import React from 'react';
import { StyledPlaySimpleBalanceLayout } from './style';
import PlaySimpleBalance from 'templates/Balances/PlaySimple';
import { BalancesSectionProps } from 'components/Headers/Header/BalancesSection/types';
import useDynamicMargins from 'components/Layouts/BalancesLayout/PlaySimpleBalanceLayout/useDynamicMargins';

export const PlaySimpleBalanceLayout: React.FC<BalancesSectionProps> = ({
  balances,
  balanceTheme,
  balanceQuantityFormat,
}) => {
  const { containerRef, itemWidths, setItemWidths, margin } = useDynamicMargins(
    balances.length,
  );

  let accumulatedWidth = 0;

  return (
    <StyledPlaySimpleBalanceLayout ref={containerRef}>
      <div className="balanceLayoutContainer">
        {balances.map(({ image, amount }, index) => {
          const currentWidth = itemWidths[index] || 0;
          const containerWidth = containerRef.current
            ? containerRef.current.offsetWidth
            : 0;

          const isFirstInRow =
            index === 0 || accumulatedWidth + currentWidth > containerWidth;

          if (isFirstInRow) {
            accumulatedWidth = currentWidth;
          } else {
            accumulatedWidth += currentWidth + margin;
          }

          const marginLeft = isFirstInRow ? 0 : margin;

          return (
            <PlaySimpleBalance
              key={`${balanceTheme}${index}`}
              image={image}
              amount={amount}
              balanceQuantityFormat={balanceQuantityFormat}
              setBalanceWidth={(width: number) => setItemWidths(index, width)}
              margin={marginLeft}
            />
          );
        })}
      </div>
    </StyledPlaySimpleBalanceLayout>
  );
};
